import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReply = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 50 50",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M48.003906 44.074219C47.945313 43.347656 46.371094 26.457031 22 26.007813L22 36.410156L0.34375 20L22 3.59375L22 14.011719C30.363281 14.203125 37.039063 16.828125 41.863281 21.816406C50.359375 30.613281 50.019531 43.488281 50 44.035156Z" })
});
export default SvgReply;
